export default __webpack_public_path__ + "static/skills-burst-mockup-1cd065e4a615badfa6653a64fee6b00c.webp";